module.exports = __webpack_public_path__ + "img/list.87976e1a.svg";